import { Component, default as React } from "react";
import { formatNumber } from "../utils/NumberUtils";

interface MainSearchBoxProps {
	playercount: number;
	registredPlayers: number;
}

interface MainSearchBoxState {
	searchedPlayer: null | string;
}

class MainSearchBox extends Component<MainSearchBoxProps & any, MainSearchBoxState> {

	constructor(props: any) {
		super(props);
		this.state = {
			searchedPlayer: null
		};
	}

	public handleSearchPlayer = (event: any) => {
		this.setState({searchedPlayer: event.target.value});
	}

	public handleSubmitSearchPlayer = (event: any) => {
		event.preventDefault();

		if (this.state.searchedPlayer === null) {
			return;
		}

		this.props.props.history.push('/player/' + this.state.searchedPlayer);
	}

	public render() {
		return (
			<div className="bg-image" style={{backgroundImage: `url(https://news.craftmania.cz/content/images/size/w2000/2020/02/1904-1024--13-.png)`}}>
				<div className="bg-gd-white-op-rl text-center">
					<div className="content content-boxed content-full py-5 py-md-7">
						<div className="row justify-content-center">
							<div className="col-md-10 col-xl-6">
								<h1 className="h2 mb-2">
									Centrum pro všechny naše <span className="text-primary">statistiky</span>.
								</h1>
								<p className="font-size-lg font-w400 text-muted">
									Hledáš statistiky hráčů, leaderboardy nebo nějaké užitečné informace?
									Zde jsi na správném místě!
								</p>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-sm-10 col-lg-8 col-xl-6">
								<div className="p-2 rounded bg-white shadow-sm">
									<form className="form-inline" method="POST" onSubmit={this.handleSubmitSearchPlayer}>
										<label className="sr-only" htmlFor="example-job-search">Nick hráče</label>
										<input type="text"
											className="form-control form-control-alt p-4 mb-2 mr-sm-2 mb-sm-0 flex-grow-1"
											id="example-job-search" name="example-job-search"
											placeholder="Nick hráče.."
											onChange={this.handleSearchPlayer}
										/>
										<button type="submit"
												className="btn btn-hero-lg btn-hero-primary flex-grow-1 flex-sm-grow-0"
												title={"Vyhledat"}>Vyhledat
										</button>
									</form>
								</div>
							</div>
						</div>
						<div className="d-flex justify-content-center mt-5">
							<div>
								<p className="px-2 px-sm-4 font-size-h3 text-dark mb-0">{formatNumber(this.props.registredPlayers)}</p>
								<p className="text-muted mb-0">
									Registrovaných hráčů
								</p>
							</div>
							<div className="px-2 px-sm-4 ml-2 ml-sm-4 border-left">
								<p className="font-size-h3 text-dark mb-0">{this.props.playercount}</p>
								<p className="text-muted mb-0">
									Online hráčů
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

export default MainSearchBox;
